import {ReportItem, ReportRow} from './ReportTypes';
import {REPORT_ACCESS} from './Constants';

const getReportDate = (date: string | null): Date | null => {
	return date ? new Date(date) : null;
};

export const mapReportToRow = (report: ReportItem, personId: string | null): ReportRow => {
	const isShared = !!report.shares?.edges?.length;
	return {
		...report,
		lastViewed: getReportDate(report.lastViewed),
		updatedAt: getReportDate(report.updatedAt),
		isShared: isShared,
		isReportOwner: report.person?.id === personId,
		favorite: !!report.favorite,
		privateAccess: !!report.privateAccess,
		access: isShared ? REPORT_ACCESS.SHARED : !report.privateAccess ? REPORT_ACCESS.COMPANY : REPORT_ACCESS.PRIVATE,
	};
};
